import React, {CSSProperties, PropsWithChildren, ReactNode} from "react";
import FunctionHelper from "../helper/FunctionHelper";
import PortalPureComponent from "./PortalPureComponent";

export enum InfoBoxType {
	SUCCESS = "success",
	INFO = "info",
	WARNING = "warning",
	DANGER = "danger"
}

interface InfoBoxProperties {
	type?: InfoBoxType;
	label?: string;
	style?: CSSProperties | undefined;
	className?: string | undefined;
}

export default class InfoBox extends PortalPureComponent<PropsWithChildren<InfoBoxProperties>, any> {
	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let classList: Array<string> = [
			"info-box", ...FunctionHelper.applyValue(this.props.className, "").split(" ")
		];

		switch (this.props.type) {
			case InfoBoxType.INFO:
				classList.push("info");
				break;
			case InfoBoxType.SUCCESS:
				classList.push("success");
				break;
			case InfoBoxType.DANGER:
				classList.push("danger");
				break;
			case InfoBoxType.WARNING:
				classList.push("warning");
				break;
		}

		return (
			<div className={classList.join(" ")} style={this.props.style}>
				<span className="box-label">{this.props.label}</span>
				<span className="box-value">{this.props.children}</span>
			</div>
		);
	}
}